import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from '@angular/router';


export class CustomReuseStrategy implements RouteReuseStrategy {

    routesToCache: Array<string> = [
        'home'
    ];

    storedRouteHandles = new Map<string, DetachedRouteHandle>();

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        let shouldDetach: boolean = this.routesToCache.indexOf(route.routeConfig.path) > -1;
        if (shouldDetach) {
            console.log('StickyRoute', route.routeConfig.path);
        }
        return shouldDetach;
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        this.storedRouteHandles.set(route.routeConfig.path, handle);
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return this.storedRouteHandles.has(route.routeConfig.path);
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
        return this.storedRouteHandles.get(route.routeConfig.path);
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/helpers/sticky.routereusestrategy.ts